import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import liveService from './liveService';

// Get token for live class
export const getToken = createAsyncThunk(
  'live/getToken',
  async ({ role, userName }, thunkAPI) => {
    try {
      return await liveService.getToken(role, userName);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = {
  token: null,
  roomId: null,
  role: null,
  userName: null,
  isConnected: false,
  isLoading: false,
  isError: false,
  message: ''
};

const liveSlice = createSlice({
  name: 'live',
  initialState,
  reducers: {
    reset: (state) => {
      state.token = null;
      state.roomId = null;
      state.role = null;
      state.userName = null;
      state.isConnected = false;
      state.isLoading = false;
      state.isError = false;
      state.message = '';
    },
    setConnected: (state, action) => {
      state.isConnected = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getToken.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getToken.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isConnected = false;
        state.token = action.payload.data.token;
        state.roomId = action.payload.data.roomId;
        state.role = action.payload.data.role;
        state.userName = action.payload.data.userName;
      })
      .addCase(getToken.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  }
});

export const { reset, setConnected } = liveSlice.actions;
export default liveSlice.reducer; 